import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ERROR_MESSAGE_SCREEN, HEADER, FILTER_FIELD } from '_constants';
// import PullToRefresh from 'react-pullable';
import { referralActions, headerActions } from 'actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReferralList from './ReferralList';
import Search from '../common/Search';
import { bottomnavActions } from '../../actions/bottomnav.actions';
import { ErrorMessage } from '../common';
import ContentLoader from 'components/common/loaders/ContentLoader';
import NoContactsIcon from 'assets/images/NoContactsIcon.svg';
import InfiniteScroll from 'react-infinite-scroll-component';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Referrals',
  hasBackButton: false,
  hasNotificationIcon: true
};

class Referrals extends React.Component {
  static propTypes = {
    search: PropTypes.func.isRequired,
    fetchReferralsCount: PropTypes.func.isRequired,
    fetchAssignedContactsForAgents: PropTypes.func.isRequired,
    setActiveReferral: PropTypes.func.isRequired,
    setHeader: PropTypes.func.isRequired,
    changeActiveItem: PropTypes.func.isRequired,
    changeReferralFilter: PropTypes.func.isRequired,
    allReferrals: PropTypes.array,
    activeReferralFilter: PropTypes.string,
    searchHasValue: PropTypes.bool
  };

  constructor (props) {
    super(props);
    this.state = {
      allReferralsCount: 0,
      activeReferralsCount: 0,
      inActiveReferralsCount: 0,
      closedReferralsCount: 0,
      page: 0,
      pageSize: 10,
      hasMore: true,
      totalLength: 0,
      dataLength: 0,
      referralsData: [],
      isLoading: true,
      searchValue: ''
    };
  }

  componentDidMount () {
    this.initilizeReferrals();
  }

  pullToRefreshHandler = () => {
    this.initilizeReferrals();
  }

  initilizeReferrals = async () => {
    const { activeReferralFilter } = this.props;
    this.props.setHeader(headerSettings);
    this.props.changeActiveItem('Referrals');
    const allReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.ALL_REFERRAL);
    const activeReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.ACTIVE_REFERRAL);
    const inActiveReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.INACTIVE_REFERRAL);
    const closedReferralsCount = await this.props.fetchReferralsCount(FILTER_FIELD.CLOSE_REFERRAL);
    const totalCount = _.isEqual(FILTER_FIELD.ALL_REFERRAL, activeReferralFilter) ? allReferralsCount : _.isEqual(FILTER_FIELD.ACTIVE_REFERRAL, activeReferralFilter) ? activeReferralsCount : _.isEqual(FILTER_FIELD.INACTIVE_REFERRAL, activeReferralFilter) ? inActiveReferralsCount : _.isEqual(FILTER_FIELD.CLOSE_REFERRAL, activeReferralFilter) ? closedReferralsCount : 0;
    await this.props.fetchAssignedContactsForAgents(this.state.page, this.state.pageSize, null, activeReferralFilter);
    await this.setState({
      referralsData: this.props.allReferrals,
      dataLength: this.props.allReferrals.length,
      totalLength: totalCount,
      allReferralsCount: allReferralsCount,
      activeReferralsCount: activeReferralsCount,
      inActiveReferralsCount: inActiveReferralsCount,
      closedReferralsCount: closedReferralsCount,
      isLoading: false,
      hasMore: !(this.props.allReferrals.length >= totalCount)
    });
  }

  handleRefferalSelection = (referral) => {
    this.props.setActiveReferral(referral);
  }

  filterOpportunities = (referrals, activeReferralFilter) => {
    let updatedReferrals = referrals.filter(referral => referral.opportunities && referral.opportunities.filter(opportunity => opportunity.opportunityType && opportunity.opportunityType === activeReferralFilter).length > 0);
    updatedReferrals = updatedReferrals.map(referral => Object.assign({}, referral));
    updatedReferrals.map(referral => referral.opportunities &&
        (referral.opportunities = referral.opportunities.filter(opportunity =>
          opportunity.opportunityType && opportunity.opportunityType === activeReferralFilter)));
    return updatedReferrals;
  }

  referralFilerHandler = async (filterKey) => {
    const filterCount = _.isEqual(filterKey, FILTER_FIELD.ALL_REFERRAL) ? this.state.allReferralsCount : _.isEqual(filterKey, FILTER_FIELD.ACTIVE_REFERRAL) ? this.state.activeReferralsCount : _.isEqual(filterKey, FILTER_FIELD.INACTIVE_REFERRAL) ? this.state.inActiveReferralsCount : _.isEqual(filterKey, FILTER_FIELD.CLOSE_REFERRAL) ? this.state.closedReferralsCount : 0;
    await this.intializeState(filterCount);
    await this.props.changeReferralFilter(filterKey);
    await this.props.fetchAssignedContactsForAgents(this.state.page, this.state.pageSize, this.state.searchValue, filterKey);
    this.setReferralsData();
  }

  fetchMoreData = async () => {
    if (this.state.dataLength >= this.state.totalLength) {
      this.setState({ hasMore: false });
      return;
    }
    if (this.state.hasMore) {
      await this.props.fetchAssignedContactsForAgents(this.state.page + 1, this.state.pageSize, this.state.searchValue, this.props.activeReferralFilter);
      this.setState({
        page: this.state.page + 1,
        referralsData: this.state.referralsData.concat(this.props.allReferrals),
        dataLength: this.state.dataLength + this.props.allReferrals.length
      });
    }
  };

  onChangeSearch = (search) => {
    this.handleSearch(search ? search.toLowerCase().trim() : '');
  }

  onClearSearch = () => {
    this.handleSearch('');
  }

  handleSearch = async (search) => {
    const { activeReferralFilter } = this.props;
    const searchCount = await this.props.fetchReferralsCount(activeReferralFilter, search);
    this.intializeState(searchCount, search);
    await this.props.fetchAssignedContactsForAgents(this.state.page, this.state.pageSize, search, activeReferralFilter);
    this.setReferralsData();
    this.props.search({ searchValue: this.state.searchValue, currentFilterKey: activeReferralFilter });
  }

  intializeState = (count, search = '') => {
    this.setState({
      page: search !== '' ? 1 : 0,
      referralsData: [],
      totalLength: count,
      dataLength: 0,
      searchValue: search,
      isLoading: true,
      hasMore: false
    });
  }

  setReferralsData = async () => {
    await this.setState({
      referralsData: this.props.allReferrals,
      dataLength: this.props.allReferrals.length,
      isLoading: false,
      hasMore: !(this.props.allReferrals.length >= this.state.totalLength)
    });
  }

  render () {
    const { allReferrals, activeReferralFilter } = this.props;
    let filteredReferrals = []; let referrals = [];
    referrals = this.state.referralsData;
    if (referrals) {
      filteredReferrals = activeReferralFilter !== FILTER_FIELD.ALL_REFERRAL ? this.filterOpportunities(referrals, activeReferralFilter) : referrals;
    }
    return (
      <React.Fragment>
        <section className='page-content referrals-page'>
          <div className='page-content-body referrals-content-body'>
            {/* <PullToRefresh
              onRefresh={this.pullToRefreshHandler}
              spinnerOffset={10}
              spinnerColor='0000FF'
            > */}
            <Search handleSearchValueChange={this.onChangeSearch} clearSearchValue={this.onClearSearch} />
            <div className='referrals-filter-container'>
              <ul>
                <li className={(activeReferralFilter === FILTER_FIELD.ALL_REFERRAL) ? 'referral-active' : ''} onClick={() => this.referralFilerHandler(FILTER_FIELD.ALL_REFERRAL)}>All <span className='referral-filter-badge'>{this.state.allReferralsCount}</span> </li>
                <li className={(activeReferralFilter === FILTER_FIELD.ACTIVE_REFERRAL) ? 'referral-active' : ''} onClick={() => this.referralFilerHandler(FILTER_FIELD.ACTIVE_REFERRAL)}>Active <span className='referral-filter-badge'> {this.state.activeReferralsCount}</span> </li>
                <li className={(activeReferralFilter === FILTER_FIELD.INACTIVE_REFERRAL) ? 'referral-active' : ''} onClick={() => this.referralFilerHandler(FILTER_FIELD.INACTIVE_REFERRAL)}>Inactive <span className='referral-filter-badge'> {this.state.inActiveReferralsCount}</span> </li>
                <li className={(activeReferralFilter === FILTER_FIELD.CLOSE_REFERRAL) ? 'referral-active' : ''} onClick={() => this.referralFilerHandler(FILTER_FIELD.CLOSE_REFERRAL)}>Closed <span className='referral-filter-badge'> {this.state.closedReferralsCount}</span> </li>
              </ul>
            </div>
            <div className='referrals-container' id='Scrollable'>
              <InfiniteScroll
                dataLength={this.state.dataLength}
                next={this.fetchMoreData}
                hasMore={this.state.hasMore}
                scrollableTarget='Scrollable'
                loader={<h6>Loading...</h6>}
              >
                { (!this.props.allReferrals || this.state.isLoading) ? <ContentLoader isLoading />
                  : allReferrals.length === 0 ? <ErrorMessage errorMessage={ERROR_MESSAGE_SCREEN.NO_CONTACTS} errorImage={NoContactsIcon} />
                    : <ReferralList
                      referrals={filteredReferrals}
                      selectRefferal={this.handleRefferalSelection}
                      searchHasValue={this.props.searchHasValue}
                      currentReferralFilter={this.props.activeReferralFilter}
                    />}
              </InfiniteScroll>

            </div>
            {/* </PullToRefresh> */}
          </div>

        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { referrals } = state;
  return {
    allReferrals: _.get(referrals, 'allReferrals', []),
    searchHasValue: _.get(referrals, 'searchHasValue', false),
    activeReferralFilter: _.get(referrals, 'activeReferralFilter', 'allReferrals')
  };
};

const mapDispatchToProps = dispatch => ({
  search: bindActionCreators(referralActions.search, dispatch),
  fetchAssignedContactsForAgents: bindActionCreators(referralActions.fetchAssignedContactsForAgents, dispatch),
  fetchReferralsCount: bindActionCreators(referralActions.fetchReferralsCount, dispatch),
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  setActiveReferral: bindActionCreators(referralActions.setActiveReferral, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  changeReferralFilter: bindActionCreators(referralActions.changeReferralFilter, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Referrals));
